window.$s = window.$s || new function() {
  var html = document.querySelector('html');
  this.showLoadingOverlay = function() {
    html.classList.add('show-loading-overlay');
  },
  this.hideLoadingOverlay = function() {
    html.classList.remove('show-loading-overlay');
  }
}

$s.AutoAddRemoveProducts = new function() {
  var debugOutput = !!(new URL(location.href).searchParams.get('debug'));
  function debug() {
    if (debugOutput) {
      console.debug.apply(this, arguments);
    }
  }
  const stringToHash = (string) => {
    let hash = 0;
    if (string.length == 0) return hash;
    for (i = 0; i < string.length; i++) {
        char = string.charCodeAt(i);
        hash = ((hash << 5) - hash) + char;
        hash = hash & hash;
    }
    return hash;
  }


  const CacheOutOfStock = new function() {
    const storage = sessionStorage;
    const storageKey = 'auto_addons_out_of_stock_variants';
    function getVariants() {
      const expireSeconds = 3600;
      let data = JSON.parse(storage.getItem(storageKey) || '{}');
      if (!data.update_ts || data.update_ts + expireSeconds*1000 < new Date().getTime()) {
        data = {update_ts: new Date().getTime()};
      }
      return data;
    }
    this.filterOutOfStock = async function (variants) {
      const data = getVariants();
      const variantsToCheck = variants.filter(id => !data[id]);
      const ret = {};
      const requests = [];
      const requestsText = [];
      const newOutOfStock = [];
    
      variantsToCheck.forEach(id => {
        const request = fetch('/variants/' + id + '?section_id=variant_info')
          .then(response => {
            if (!response.ok) {
              throw new Error(`HTTP ${response.status} for variant ${id}`);
            }
    
            const responseText = response.text();
            requestsText.push(responseText);
    
            return responseText.then(text => {
              try {
                if (!text) {
                  console.error("Empty response for variant", id);
                  return;
                }
    
                const start = text.indexOf('>') + 1;
                const end = text.lastIndexOf('</');
    
                if (start <= 0 || end <= start) {
                  console.error("Invalid HTML wrapper for variant", id, text);
                  return;
                }
    
                const jsonString = text.substring(start, end).trim();
    
                if (!jsonString) {
                  console.error("Extracted empty JSON for variant", id, text);
                  return;
                }
        
                const info = JSON.parse(jsonString);
    
                if (info.available) {
                  ret[id] = 1;
                } else {
                  newOutOfStock.push(id);
                }
    
              } catch (err) {
                console.error("Failed to parse variant", id, err, text);
              }
            });
          })
          .catch(err => {
            console.error("Fetch failed for variant", id, err);
          });
    
        requests.push(request);
      });
    
      await Promise.all(requests);
      await Promise.all(requestsText);
    
      if (newOutOfStock.length > 0) {
        const newData = getVariants();
        newOutOfStock.forEach(id => { newData[id] = 1; });
        storage.setItem(storageKey, JSON.stringify(newData));
      }
    
      return ret;
    };    
    
  }
  
  //standalone post method
  function postUpdate(url, data) {
    var headers = {}
    if (!(data instanceof FormData || typeof data==='string')) {
      headers["Content-Type"] = "application/json";
    }
    return fetch(url, {
      "method": "POST",
      "body": (data instanceof FormData || typeof data==='string' ? data : JSON.stringify(data)),
      "headers": headers
    }).then(res => res.json())
  }

  var autoAddRemoveProductsRules = [];
  function createSettings(promoName, allowedItems = [], autoRemove = true, maxUses = 1) {
    var allowedItems = allowedItems||[];
    allowedItems.forEach(x=> {
      if (!x.properties) x.properties = {};
      x.properties._promo = promoName;
      x.properties.Promo = promoName;
    });
    return {"promoName": promoName, "allowedItems": allowedItems, "autoRemove": autoRemove, "maxUses": maxUses };
  }

  function createConditionRequiredDiscountCode(discountCode) { //discount code must be stored in a line_item property with name '_discount_code'. The first line_item with such code is the only valid code.
    var condition = createConditionCustom(function(cart) {
      //cart.discount_codes is an array of objects fetched from cart.js
      //cart.discount_codes_applicable is an array of code strings from liquid
      let codes = cart.discount_codes ? cart.discount_codes.map(x=>x.code.toLowerCase()) : [];
      codes.push(...cart.discount_codes_applicable ? cart.discount_codes_applicable.map(x=>x.toLowerCase()) : []);
      return codes.includes(discountCode.toLowerCase());
    });
    return condition;
  }

  function itemMatch(item, query) { //recursive function
    var equal = !!item;
    for (var p in query) {
      if (!equal)
        return false;
      var type = typeof(query[p]);
      if (type=='object') {
        equal = equal && itemMatch(item[p], query[p]);
      } else if(type=='array') {
        for (var i=0; equal && i<item[p].length; i++) {
          equal = equal && item[p][i]===query[p][i];
        }
      } else {
        equal = equal && item[p]===query[p];
      }
    }
    return equal;
  }

  function findItems(cart, itemQuery) {
    var items = cart.items.filter(function(item) {
        return itemMatch(item, itemQuery);
      });
    return items;
  }

  function createCartFilter(itemQueries) {
    return function(cart, promoName) {
      var newCart = Object.assign({}, cart);
      if ($s.AutoAddRemoveProductsCart.itemsToExclude[promoName]) {
        newCart.items = newCart.items.filter(item=>{
          var ok = (item.properties && item.properties._promo == promoName)
            || $s.AutoAddRemoveProductsCart.itemsToExclude[this.settings.promoName].indexOf(item.id) == -1;
          return ok;
        });
      }
      if (itemQueries.length > 0) {
        newCart.items = newCart.items.filter(item=>{
          if (item.properties && item.properties._promo == promoName) {
            return true;
          }

          for (var i=0; i<itemQueries.length; i++) {
            if (itemMatch(item, itemQueries[i])) {
              return true;
            }
          }
          return false;
        });
      }
      return newCart;
    }
  }
  function createConditionRequiredCustomerTags(tags) {
    tags = tags.split(',').map(x => x.trim().toLowerCase());
  
    return createConditionCustom(function(cart) {
      // Safely get customer tags array
      const customerTags = cart.customer && cart.customer.tags
        ? cart.customer.tags.split(',').map(x => x.trim().toLowerCase())
        : [];
  
      // Return true if ANY required tag matches customer's tags
      return tags.some(tag => customerTags.includes(tag));
    });
  }
  
  function createConditionMinAmount(amount) { //amount in dollars with decimals
    amount = amount * 100;
    var condition = createConditionCustom(function(cart) {
      var total = 0;
      cart.items.forEach((item)=>{
        if (!item.properties || !item.properties._promo) {
          total += item.original_line_price
        }
      });
      if (amount>0) {
        var times = Math.floor(total/amount);
        cart.passedTimes = cart.passedTimes==-1 ? times : Math.min(cart.passedTimes, times);
      }
      return (total >= amount);
    });
    return condition;
  }

  function parseTiers(str) {
    let tiersToCheck = str.split(",");
    let hasTier = tiersToCheck.some(tier => window.customerTags.includes(tier));
    var condition = createConditionCustom(function() {
      return hasTier;
    });

    return condition;
  }
  
  function createConditionMaxAmount(amount) { //amount in dollars with decimals
    amount = amount * 100;
    var condition = createConditionCustom(function(cart) {
      var total = 0;
      cart.items.forEach((item)=>{
        if (!item.properties || !item.properties._promo) {
          total += item.original_line_price
        }
      });

      var times = total<amount ? 1 : 0;
      cart.passedTimes = cart.passedTimes==-1 ? times : Math.min(cart.passedTimes, times);

      return (total<amount);
    });
    return condition;
  }
  function createConditionMinQuantity(minQuantity) { //min quantity of products to pass the requirements
    var condition = createConditionCustom(function(cart) {
      var total = 0;
      cart.items.forEach((item)=>{
        if (!item.properties || !item.properties._promo) {
          total += item.quantity
        }
      });
      if (minQuantity>0) {
        var times = Math.floor(total/minQuantity);
        cart.passedTimes = cart.passedTimes==-1 ? times : Math.min(cart.passedTimes, times);
      }
      return (total >= minQuantity);
    });
    return condition;
  }

  function calcPassedUses(passedTimes, settings) {
    var uses = settings.maxUses ? settings.maxUses : passedTimes; //if not maxUses, then there is no limit;
    return (passedTimes>1 ? Math.min(uses, passedTimes) : 1);
  }
  
  //recommended to validate the quantity of promo items in cart, you should include filter "properties: {_promo: promoName}"
  function createConditionMaxQuantity(itemQuery, maxQuantity) {  //object with line_item attributes. | integer
    var condition = createConditionCustom(function(cart, settings) {
      var itemsPromo = findItems(cart, itemQuery);
      var total = 0;
      itemsPromo.forEach(item=>{total += item.quantity});
      var uses = calcPassedUses(cart.passedTimes, settings);
      if (uses>1) {
        return total <= maxQuantity * uses;
      }
      return total<=maxQuantity;
    });
    return condition;
  }
  function createConditionCustom(conditionLogic) {
    var condition = new function() {
      this.logic = conditionLogic;
    }
    return condition;
  }
  function createActionAllowGWP() {
    var action = createActionCustom(function(rule, settings, cart, requirementsPassed) {
      var query = {properties: {_promo: settings.promoName}};
      var itemsPromo = findItems(cart, query);
      if (requirementsPassed) {
        debug('AutoAddons: requirements passed');
        settings.allowedItems.forEach(function(item) {
          var itemExist = itemsPromo.find(i=>i.id==item.id);
          cart.passedUses = calcPassedUses(cart.passedTimes, settings); //if not maxUses, then there is no limit;
          item.quantity = item.maxQuantity * cart.passedUses;
          if (!itemExist) {
            if (item.autoAdd) {
              if (item.one_by_product) {
                var existingItem = itemsPromo.find(i=>i.product_id==item.product_id);
                if (!existingItem) {
                  const variantOptions = settings.allowedItems.filter(x=>x.product_id==item.product_id).map(x=>{return 'gid://shopify/ProductVariant/'+x.id });
                  item.properties['_edit_options'] = JSON.stringify({v:variantOptions});
                  rule.cartOut.addItems.push(item);
                  debug('AutoAddons: add One By Product', item);
                }
              } else {
                rule.cartOut.addItems.push(item);
                debug('AutoAddons: add', item);
              }
            } else {
              rule.cartOut.allowItems.push(item);
              debug('AutoAddons: no action because autoAdd is false', item);
            }
          } else {
            if (item.quantity != itemExist.quantity) {
              itemExist = Object.assign({}, itemExist); //copy to not modify the source
              if (item.autoAdd || item.quantity < itemExist.quantity) {
                itemExist.quantity = item.quantity;
                rule.cartOut.updateItems.push(itemExist);
                debug('AutoAddons: update item quantity');
              } else {
                itemExist.quantity = item.quantity - itemExist.quantity; //quantity allowed to increase;
                rule.cartOut.allowItems.push(itemExist);
                debug('AutoAddons: allow item:', item, '\nno update because item.autoAdd=' + (item.autoAdd?'true':'false') + ', item.quantity=' + item.quantity + ', itemExist.quantity=' + itemExist.quantity);
              }
            } else {
              debug('AutoAddons: no action, item already in cart');                
            }
          }
        })
      } else {
        debug('AutoAddons: requirements not passed');
        if (itemsPromo.length>0) {
          if (settings.autoRemove) {
            itemsPromo.forEach(x=>x.quantity = 0);
            rule.cartOut.updateItems = itemsPromo;
            debug('AutoAddons: remove', itemsPromo);
          } else {
            debug('AutoAddons: autoremove=false, invalid item remains in cart');
          }
        } else {
          debug('AutoAddons: no action, item not in cart');
        }
      }
    });
    return action;
  }
  function createActionCustom(actionLogic) { //actionLogic is a function with parameters: rule, settings, cart, requirementsPassed
    var action = new function() {
      this.logic = actionLogic;
    }
    return action;
  }
  class Rule extends EventTarget {
    constructor(settings, requiredConditions, action, cartFilter) {
      super();
      this.settings = settings;
      this.requiredConditions = requiredConditions;
      this.action = action;
      this.cartOut = null;
      this.cartFilter = cartFilter;
      this.run = (cart) => {
        this.cartOut = {addItems: [], updateItems: [], allowItems: []};
        var cartForConditions = this.cartFilter(cart, this.settings.promoName);
        cartForConditions.passedTimes = -1;
        var passed = validateConditions(cartForConditions, this.requiredConditions, this.settings);
        cart.passedTimes = cartForConditions.passedTimes;
        this.action.logic(this, this.settings, cart, passed);
        this.dispatchEvent(new CustomEvent('run', {detail: {rule: this, passed}}));

        return passed;
      }
      this.start = ()=> {
        if (autoAddRemoveProductsRules.indexOf(this)==-1) {
          autoAddRemoveProductsRules.push(this);
        }
      }
      this.stop = ()=> {
        var index = autoAddRemoveProductsRules.indexOf(this);
        if (index>-1) {
          autoAddRemoveProductsRules.splice(index, 1);
        }
      }
      this.start();
    }
  }
  function createRule(settings, requiredConditions, action, cartFilter)  {
    var rule = new Rule(settings, requiredConditions, action, cartFilter);
    return rule;
  }
  function validateConditions(cart, conditions, settings) { //returns true if all conditions are met, otherwise return false
    return !conditions.find(c=>{var r = !c.logic(cart, settings); if (r){debug('AutoAddons: condition not passed', c.logic)}; return r;});
  }
  function getRules() {
    return autoAddRemoveProductsRules;
  }
  function runAllRules(cart, updateCart=true) {
    var cartOut = {addItems: [], updateItems: [], allowItems: []};
    var validPromos = [];
    var promise = new Promise(async (resolve, reject)=> {

      if (window.Shopify && Shopify.designMode) {
        resolve({validPromos: validPromos, modified: false});
        return;
      }

      for (var i=0; i<autoAddRemoveProductsRules.length; i++) {
        var rule = autoAddRemoveProductsRules[i];
        var cartCopy = Object.assign({}, cart);
        if (rule.run(cartCopy)) {
          
          validPromos.push({promoName: rule.settings.promoName, rule: rule, cart: cartCopy, thresholdMet: true});
        } else if (window.promoAlwaysVisibleNames && window.promoAlwaysVisibleNames.indexOf(rule.settings.promoName) !== -1) {
          validPromos.push({promoName: rule.settings.promoName, rule: rule, cart: cartCopy, thresholdMet: false});
        }
        rule.cartOut.addItems.forEach(x=>cartOut.addItems.push(x));
        rule.cartOut.updateItems.forEach(x=>cartOut.updateItems.push(x));
        rule.cartOut.allowItems.forEach(x=>cartOut.allowItems.push(x));
      };

      //remove items from promotions not available, or invalid promo items
      cart.items.forEach(function(item) {
        if (item.properties && item.properties['_promo']) {
          var rule = autoAddRemoveProductsRules.find(rule=>rule.settings.promoName==item.properties['_promo']);
          if (!rule || !rule.settings.allowedItems.find(x=>x.id==item.id) || rule.settings.promo_hash!=item.properties['_promo_hash']) {
            item.quantity = 0;
            cartOut.updateItems.push(item);
          }
        }
      });

      async function handleError(msg, payload) {
        console.error('Couldn\'t update cart: ', msg, payload);
        var clearResponse = fetch('/cart/clear.json');
        msg += (msg ? '\n\n': '') + lngg.cart__auto_addons_js__error_clear_cart_message;
        alert(msg);
        await clearResponse;
      }

      if (updateCart) {
        var modified = false;
        if (cartOut.updateItems.length > 0) {
          var items = {}
          $s.showLoadingOverlay();
          cartOut.updateItems.forEach(x=>{items[x.key] = x.quantity});
          var data = {updates: items};
          //await $s.cartUpdateDataFix(data);
          var newCart = await postUpdate('/cart/update.js', data);
          modified = true;
          $s.hideLoadingOverlay();
        }
        if (cartOut.addItems.length > 0) {
          var inStockVariants = await CacheOutOfStock.filterOutOfStock(cartOut.addItems.map(x=>x.id));
          var inStockItems = cartOut.addItems.filter(x=>{return inStockVariants[x.id]});
          var items = [];
          inStockItems.forEach(item=>{
            if (!item.one_by_product || !items.find(x=>x.product_id==item.product_id)) {
              items.push(item);
            }
          })
          
          if (items.length>0) {
            $s.showLoadingOverlay();
            var newItem = await postUpdate('/cart/add.js', {items: items});
            if (newItem.status) {
              await handleError(newItem.description, items);
            }
            modified = true;
            $s.hideLoadingOverlay();
          }
        }
        resolve({validPromos: validPromos, modified: modified});
      } else {
        resolve({validPromos: validPromos, modified: false});
      }

    });
    return promise;
  }
  return {
    createSettings: createSettings,
    createConditionRequiredDiscountCode: createConditionRequiredDiscountCode,
    createConditionRequiredCustomerTags: createConditionRequiredCustomerTags,
    createConditionMinAmount: createConditionMinAmount,
    createConditionMaxAmount: createConditionMaxAmount,
    createConditionMinQuantity: createConditionMinQuantity,
    createConditionMaxQuantity: createConditionMaxQuantity,
    createConditionCustom: createConditionCustom,
    parseTiers: parseTiers,
    createCartFilter: createCartFilter,
    createActionAllowGWP: createActionAllowGWP,
    createActionCustom: createActionCustom,
    validateConditions: validateConditions,
    createRule: createRule,
    getRules: getRules,
    runAllRules: runAllRules,
    postUpdate: postUpdate,
    stringToHash: stringToHash
  }
}
$s.AutoAddRemoveProductsCart = {itemsToExclude: {} };(function() {
      try {
        const promoStr = `a:Sachet GWP,b:6551332651123_39285388476531, 7338942464115_41148905193587, 6960172859507_40412951150707, 6706280792179_39645972299891, 7118932213875_40771341811827, 4626206326899_32139382620275, 7849130950771_42640996663411, 7849129640051_42640979689587, 7898714996851_42841787990131, 4574034362483_31992943902835, 7329447411827_41127110410355, 6801904894067_39949169295475, 7041350860915_40582366199923, 7858776309875_42678334914675, 4519236337779_31774281236595,c:0,d:sachets-in-checkout,e:2`
        const promoHash = $s.AutoAddRemoveProducts.stringToHash(promoStr);

        
        

        var util = $s.AutoAddRemoveProducts;
        var promoName = "Sachet GWP";
        var conditions = [];
        var cartItemsFilter = util.createCartFilter([]); //filter tags and collections by default

        
conditions.push(util.createConditionMinQuantity(1));
        




conditions.push(util.createConditionMaxQuantity({properties: {_promo: promoName}}, 2));var variantIds = ["6551332651123_39285388476531","7338942464115_41148905193587","6960172859507_40412951150707","6706280792179_39645972299891","7118932213875_40771341811827","4626206326899_32139382620275","7849130950771_42640996663411","7849129640051_42640979689587","7898714996851_42841787990131","4574034362483_31992943902835","7329447411827_41127110410355","6801904894067_39949169295475","7041350860915_40582366199923","7858776309875_42678334914675","4519236337779_31774281236595"];
        var allowedProducts = variantIds.map(function(data) {
          var parts = data.split(':');
          var quantity = parts[1] ? parts[1]/1 : 1;
          const [prodId, varId] = parts[0].split('_');
          var obj = {id: varId/1, product_id: prodId/1, one_by_product: false, quantity: quantity, properties: {_locked: 'true', _promo_hash: promoHash}, maxQuantity: quantity, autoAdd: false };
          if (parts[2]) {
            obj['selling_plan'] = parts[2]/1;
          }
          return obj;
        });
        var settings = util.createSettings(promoName, allowedProducts, true, 1);
        settings.promo_hash = promoHash;
        
        var action = util.createActionAllowGWP();

        var rule = util.createRule(settings, conditions, action, cartItemsFilter);
      } catch (e) {
        console.error(e);
      }

    })();(function() {
      try {
        const promoStr = `a:Free Mini Dew Drops,b:8118223110259_44046493614195,c:0,d:,e:2`
        const promoHash = $s.AutoAddRemoveProducts.stringToHash(promoStr);

        
        

        var util = $s.AutoAddRemoveProducts;
        var promoName = "Free Mini Dew Drops";
        var conditions = [];
        var cartItemsFilter = util.createCartFilter([]); //filter tags and collections by default

        
conditions.push(util.createConditionMinQuantity(1));
        

conditions.push(util.createConditionMinAmount(70));
        

conditions.push(util.createConditionRequiredDiscountCode("Q6ZH0XBC8K1H"));
        
var variantIds = ["8118223110259_44046493614195"];
        var allowedProducts = variantIds.map(function(data) {
          var parts = data.split(':');
          var quantity = parts[1] ? parts[1]/1 : 1;
          const [prodId, varId] = parts[0].split('_');
          var obj = {id: varId/1, product_id: prodId/1, one_by_product: false, quantity: quantity, properties: {_locked: 'true', _promo_hash: promoHash}, maxQuantity: quantity, autoAdd: true };
          if (parts[2]) {
            obj['selling_plan'] = parts[2]/1;
          }
          return obj;
        });
        var settings = util.createSettings(promoName, allowedProducts, true, 1);
        settings.promo_hash = promoHash;
        
        var action = util.createActionAllowGWP();

        var rule = util.createRule(settings, conditions, action, cartItemsFilter);
      } catch (e) {
        console.error(e);
      }

    })();(function() {
      try {
        const promoStr = `a:Club Glow Welcome Gift,b:7338942169203_41148904865907:1,8045687898227_43226218266739:1,c:0,d:,e:2`
        const promoHash = $s.AutoAddRemoveProducts.stringToHash(promoStr);

        
        

        var util = $s.AutoAddRemoveProducts;
        var promoName = "Club Glow Welcome Gift";
        var conditions = [];
        var cartItemsFilter = util.createCartFilter([]); //filter tags and collections by default

        
conditions.push(util.createConditionMinQuantity(1));
        



conditions.push(util.createConditionRequiredDiscountCode("CG23WO"));
        
var variantIds = ["7338942169203_41148904865907:1","8045687898227_43226218266739:1"];
        var allowedProducts = variantIds.map(function(data) {
          var parts = data.split(':');
          var quantity = parts[1] ? parts[1]/1 : 1;
          const [prodId, varId] = parts[0].split('_');
          var obj = {id: varId/1, product_id: prodId/1, one_by_product: false, quantity: quantity, properties: {_locked: 'true', _promo_hash: promoHash}, maxQuantity: quantity, autoAdd: true };
          if (parts[2]) {
            obj['selling_plan'] = parts[2]/1;
          }
          return obj;
        });
        var settings = util.createSettings(promoName, allowedProducts, true, 1);
        settings.promo_hash = promoHash;
        
        var action = util.createActionAllowGWP();

        var rule = util.createRule(settings, conditions, action, cartItemsFilter);
      } catch (e) {
        console.error(e);
      }

    })();(function() {
      try {
        const promoStr = `a:Employee Gratis Serum,b:8041256550515_43212232917107,c:0,d:,e:2`
        const promoHash = $s.AutoAddRemoveProducts.stringToHash(promoStr);

        
        

        var util = $s.AutoAddRemoveProducts;
        var promoName = "Employee Gratis Serum";
        var conditions = [];
        var cartItemsFilter = util.createCartFilter([]); //filter tags and collections by default

        




conditions.push(util.createConditionRequiredDiscountCode("PPGRATIS-J07UL25"));
        
var variantIds = ["8041256550515_43212232917107"];
        var allowedProducts = variantIds.map(function(data) {
          var parts = data.split(':');
          var quantity = parts[1] ? parts[1]/1 : 1;
          const [prodId, varId] = parts[0].split('_');
          var obj = {id: varId/1, product_id: prodId/1, one_by_product: false, quantity: quantity, properties: {_locked: 'true', _promo_hash: promoHash}, maxQuantity: quantity, autoAdd: true };
          if (parts[2]) {
            obj['selling_plan'] = parts[2]/1;
          }
          return obj;
        });
        var settings = util.createSettings(promoName, allowedProducts, true, 1);
        settings.promo_hash = promoHash;
        
        var action = util.createActionAllowGWP();

        var rule = util.createRule(settings, conditions, action, cartItemsFilter);
      } catch (e) {
        console.error(e);
      }

    })();(function() {
      try {
        const promoStr = `a:Amex Centurion Free Gift,b:7799989534835_42419805814899,c:0,d:,e:2`
        const promoHash = $s.AutoAddRemoveProducts.stringToHash(promoStr);

        
        

        var util = $s.AutoAddRemoveProducts;
        var promoName = "Amex Centurion Free Gift";
        var conditions = [];
        var cartItemsFilter = util.createCartFilter([]); //filter tags and collections by default

        
conditions.push(util.createConditionMinQuantity(1));
        



conditions.push(util.createConditionRequiredDiscountCode("XG2RA5"));
        
var variantIds = ["7799989534835_42419805814899"];
        var allowedProducts = variantIds.map(function(data) {
          var parts = data.split(':');
          var quantity = parts[1] ? parts[1]/1 : 1;
          const [prodId, varId] = parts[0].split('_');
          var obj = {id: varId/1, product_id: prodId/1, one_by_product: false, quantity: quantity, properties: {_locked: 'true', _promo_hash: promoHash}, maxQuantity: quantity, autoAdd: true };
          if (parts[2]) {
            obj['selling_plan'] = parts[2]/1;
          }
          return obj;
        });
        var settings = util.createSettings(promoName, allowedProducts, true, 1);
        settings.promo_hash = promoHash;
        
        var action = util.createActionAllowGWP();

        var rule = util.createRule(settings, conditions, action, cartItemsFilter);
      } catch (e) {
        console.error(e);
      }

    })();(function() {
      try {
        const promoStr = `a:Bouncy Skin Duo,b:6787598418035_39908225712243:1,8083850690675_43775084920947:1,c:1,d:,e:2`
        const promoHash = $s.AutoAddRemoveProducts.stringToHash(promoStr);

        
        

        var util = $s.AutoAddRemoveProducts;
        var promoName = "Bouncy Skin Duo";
        var conditions = [];
        var cartItemsFilter = util.createCartFilter([]); //filter tags and collections by default

        
conditions.push(util.createConditionMinQuantity(1));
        

conditions.push(util.createConditionMinAmount(75));
        

conditions.push(util.createConditionRequiredDiscountCode("BOUNCYDUO"));
        
var variantIds = ["6787598418035_39908225712243:1","8083850690675_43775084920947:1"];
        var allowedProducts = variantIds.map(function(data) {
          var parts = data.split(':');
          var quantity = parts[1] ? parts[1]/1 : 1;
          const [prodId, varId] = parts[0].split('_');
          var obj = {id: varId/1, product_id: prodId/1, one_by_product: true, quantity: quantity, properties: {_locked: 'true', _promo_hash: promoHash}, maxQuantity: quantity, autoAdd: true };
          if (parts[2]) {
            obj['selling_plan'] = parts[2]/1;
          }
          return obj;
        });
        var settings = util.createSettings(promoName, allowedProducts, true, 1);
        settings.promo_hash = promoHash;
        
        var action = util.createActionAllowGWP();

        var rule = util.createRule(settings, conditions, action, cartItemsFilter);
      } catch (e) {
        console.error(e);
      }

    })();(function() {
      try {
        const promoStr = `a:SHOP MY STRETCH TOTE,b:8155748892787_44174099611763,c:0,d:,e:2`
        const promoHash = $s.AutoAddRemoveProducts.stringToHash(promoStr);

        
        

        var util = $s.AutoAddRemoveProducts;
        var promoName = "SHOP MY STRETCH TOTE";
        var conditions = [];
        var cartItemsFilter = util.createCartFilter([]); //filter tags and collections by default

        
conditions.push(util.createConditionMinQuantity(1));
        

conditions.push(util.createConditionMinAmount(15));
        

conditions.push(util.createConditionRequiredDiscountCode("SHOPMYGIFT"));
        
var variantIds = ["8155748892787_44174099611763"];
        var allowedProducts = variantIds.map(function(data) {
          var parts = data.split(':');
          var quantity = parts[1] ? parts[1]/1 : 1;
          const [prodId, varId] = parts[0].split('_');
          var obj = {id: varId/1, product_id: prodId/1, one_by_product: false, quantity: quantity, properties: {_locked: 'true', _promo_hash: promoHash}, maxQuantity: quantity, autoAdd: true };
          if (parts[2]) {
            obj['selling_plan'] = parts[2]/1;
          }
          return obj;
        });
        var settings = util.createSettings(promoName, allowedProducts, true, 1);
        settings.promo_hash = promoHash;
        
        var action = util.createActionAllowGWP();

        var rule = util.createRule(settings, conditions, action, cartItemsFilter);
      } catch (e) {
        console.error(e);
      }

    })();(function() {
      try {
        const promoStr = `a:Made With Pride Duo,b:8269141966963_44962638200947,c:0,d:,e:2`
        const promoHash = $s.AutoAddRemoveProducts.stringToHash(promoStr);

        
        

        var util = $s.AutoAddRemoveProducts;
        var promoName = "Made With Pride Duo";
        var conditions = [];
        var cartItemsFilter = util.createCartFilter([]); //filter tags and collections by default

        


conditions.push(util.createConditionMinAmount(85));
        

conditions.push(util.createConditionRequiredDiscountCode("PRIDEDUO26"));
        
var variantIds = ["8269141966963_44962638200947"];
        var allowedProducts = variantIds.map(function(data) {
          var parts = data.split(':');
          var quantity = parts[1] ? parts[1]/1 : 1;
          const [prodId, varId] = parts[0].split('_');
          var obj = {id: varId/1, product_id: prodId/1, one_by_product: false, quantity: quantity, properties: {_locked: 'true', _promo_hash: promoHash}, maxQuantity: quantity, autoAdd: true };
          if (parts[2]) {
            obj['selling_plan'] = parts[2]/1;
          }
          return obj;
        });
        var settings = util.createSettings(promoName, allowedProducts, true, 1);
        settings.promo_hash = promoHash;
        
        var action = util.createActionAllowGWP();

        var rule = util.createRule(settings, conditions, action, cartItemsFilter);
      } catch (e) {
        console.error(e);
      }

    })();(function() {
      try {
        const promoStr = `a:Free Clear Skin Routine,b:8296790982771_45116531376243,c:0,d:,e:2`
        const promoHash = $s.AutoAddRemoveProducts.stringToHash(promoStr);

        
        

        var util = $s.AutoAddRemoveProducts;
        var promoName = "Free Clear Skin Routine";
        var conditions = [];
        var cartItemsFilter = util.createCartFilter([]); //filter tags and collections by default

        


conditions.push(util.createConditionMinAmount(75));
        


var variantIds = ["8296790982771_45116531376243"];
        var allowedProducts = variantIds.map(function(data) {
          var parts = data.split(':');
          var quantity = parts[1] ? parts[1]/1 : 1;
          const [prodId, varId] = parts[0].split('_');
          var obj = {id: varId/1, product_id: prodId/1, one_by_product: false, quantity: quantity, properties: {_locked: 'true', _promo_hash: promoHash}, maxQuantity: quantity, autoAdd: true };
          if (parts[2]) {
            obj['selling_plan'] = parts[2]/1;
          }
          return obj;
        });
        var settings = util.createSettings(promoName, allowedProducts, true, 1);
        settings.promo_hash = promoHash;
        
        var action = util.createActionAllowGWP();

        var rule = util.createRule(settings, conditions, action, cartItemsFilter);
      } catch (e) {
        console.error(e);
      }

    })();(function() {
      try {
        const promoStr = `a:New Customer Offer,b:8155748892787_44174099611763,c:0,d:,e:2`
        const promoHash = $s.AutoAddRemoveProducts.stringToHash(promoStr);

        
        

        var util = $s.AutoAddRemoveProducts;
        var promoName = "New Customer Offer";
        var conditions = [];
        var cartItemsFilter = util.createCartFilter([]); //filter tags and collections by default

        
conditions.push(util.createConditionMinQuantity(1));
        

conditions.push(util.createConditionMinAmount(55));
        

conditions.push(util.createConditionRequiredDiscountCode("STRETCHTOTE26"));
        
var variantIds = ["8155748892787_44174099611763"];
        var allowedProducts = variantIds.map(function(data) {
          var parts = data.split(':');
          var quantity = parts[1] ? parts[1]/1 : 1;
          const [prodId, varId] = parts[0].split('_');
          var obj = {id: varId/1, product_id: prodId/1, one_by_product: false, quantity: quantity, properties: {_locked: 'true', _promo_hash: promoHash}, maxQuantity: quantity, autoAdd: true };
          if (parts[2]) {
            obj['selling_plan'] = parts[2]/1;
          }
          return obj;
        });
        var settings = util.createSettings(promoName, allowedProducts, true, 1);
        settings.promo_hash = promoHash;
        
        var action = util.createActionAllowGWP();

        var rule = util.createRule(settings, conditions, action, cartItemsFilter);
      } catch (e) {
        console.error(e);
      }

    })();(function() {
      try {
        const promoStr = `a:Choose your free mini,b:8083850690675_43775084920947,8118223110259_44046493614195,c:0,d:sachets-in-checkout-copy,e:1`
        const promoHash = $s.AutoAddRemoveProducts.stringToHash(promoStr);

        
        

        var util = $s.AutoAddRemoveProducts;
        var promoName = "Choose your free mini";
        var conditions = [];
        var cartItemsFilter = util.createCartFilter([]); //filter tags and collections by default

        


conditions.push(util.createConditionMinAmount(65));
        


conditions.push(util.createConditionMaxQuantity({properties: {_promo: promoName}}, 1));var variantIds = ["8083850690675_43775084920947","8118223110259_44046493614195"];
        var allowedProducts = variantIds.map(function(data) {
          var parts = data.split(':');
          var quantity = parts[1] ? parts[1]/1 : 1;
          const [prodId, varId] = parts[0].split('_');
          var obj = {id: varId/1, product_id: prodId/1, one_by_product: false, quantity: quantity, properties: {_locked: 'true', _promo_hash: promoHash}, maxQuantity: quantity, autoAdd: false };
          if (parts[2]) {
            obj['selling_plan'] = parts[2]/1;
          }
          return obj;
        });
        var settings = util.createSettings(promoName, allowedProducts, true, 1);
        settings.promo_hash = promoHash;
        
        var action = util.createActionAllowGWP();

        var rule = util.createRule(settings, conditions, action, cartItemsFilter);
      } catch (e) {
        console.error(e);
      }

    })();window.FreeSamples = new function () {
  this.initSections = function(validPromos) {
    validPromos.forEach(function(promo) {
      var section = document.querySelector('.free-samples-selector[data-promo="'+promo.promoName+'"]');
      if (section) {
        section.style.display = 'block';
        if(section.classList.contains('hidden-elem')){
          section.classList.remove('hidden-elem')
        }
        const cartPromoitems = promo.cart.items.filter(x=>x.properties && x.properties['_promo']==promo.promoName)
        var allowedQuantity = section.dataset.maxItems;

        var selectedQuantity = 0;
        cartPromoitems.forEach((item)=>{selectedQuantity += item.quantity/1;});

        section.querySelectorAll('.section-title .allowed, .section-text .allowed').forEach((elem)=> {
          elem.innerHTML = allowedQuantity;
        });
        section.querySelectorAll('.section-title .selected, .section-text .selected').forEach((elem)=> {
          elem.innerHTML = selectedQuantity;
        });
        section.querySelectorAll('.section-title.single, .section-text.single').forEach((elem)=> {
          elem.style.display = allowedQuantity==1 ? '' : 'none';
        });
        section.querySelectorAll('.section-title.multiple, .section-text.multiple').forEach((elem)=> {
          elem.style.display = allowedQuantity>1 ? '' : 'none';
        });

        var thresholdNotMet = promo.thresholdMet === false;
        var allowItemsSource = thresholdNotMet ? (promo.rule.settings.allowedItems || []) : promo.rule.cartOut.allowItems;
        var disabled = thresholdNotMet || (selectedQuantity >= allowedQuantity);

        const samples = section.querySelectorAll('.item-sample');
        samples.forEach(function(sample) {
          sample.allowedItems = allowItemsSource.filter(x=>x.product_id==sample.dataset.productId);
          sample.cartItems = cartPromoitems.filter(x=>x.product_id==sample.dataset.productId);
          sample.addDisabled = disabled;
          sample.settings = promo.rule.settings;
          sample.updateForm();
        });

        /*
        var carousel = section.querySelector('component-carousel')
        if (carousel.initSlider) {
          carousel.initSlider();
        } else {
          carousel.setAttribute('data-init-ondemand', 'false');
        }*/
        section.querySelector('free-sample-carousel').initCarousel();
      }
    });    
  }

}

class ComponentFreeSampleCard extends HTMLElement {
  constructor() {
    super()
    var self = this;
    self.section = this.closest('.free-samples-selector');
    self.util = $s.AutoAddRemoveProducts;
    self.remove = this.querySelector('.remove-sample');
    self.update = this.querySelector('.quantity-input');
    self.add = this.querySelector('.add');
    self.variantSelector = this.querySelector('[name="id"]');
    self.allowedItems = [];
    self.cartItems = [];
    self.addDisabled = true;
    self.settings = null;
    self.updateForm = function() {
      const variantId = self.variantSelector.value;
      const allowedItem = self.allowedItems.find(item=>item.id==variantId);
      const cartItem = self.cartItems.find(item=>item.id==variantId);
      self.setAttribute('data-edit', 'none');
      if (!cartItem) {
        if (allowedItem) {
          self.setAttribute('data-edit', 'add');
        }
      } else {
        self.dataset.key = cartItem.key;
        self.querySelector('.quantity-input').value = cartItem.quantity;
        if (allowedItem) {
          self.setAttribute('data-edit', 'remove');
        } else if (cartItem.quantity>1) {
          self.setAttribute('data-edit', 'remove-quantity');
        } else {
          self.setAttribute('data-edit', 'remove');
        }
      }
      
      self.querySelectorAll('.add, .quantity-button.plus').forEach(function(btn) {
        if (self.addDisabled) {
          btn.setAttribute('disabled', true);
        } else {
          btn.removeAttribute('disabled');
        }
      });

    }
    self.variantSelector.addEventListener('change', self.updateForm);
    self.updateForm();

    async function updateUI() {
      var sectionCart = window.SideCart ? 'side_cart' : 'cart_content';
      $s.getJson({url: '/?sections='+sectionCart, success: async function(data){
        $s.hideLoadingOverlay();
        if (window.SideCart) {
          window.SideCart.openAfterUpdate = true;
        }
        var parser = new DOMParser();
        var doc = parser.parseFromString(data[sectionCart], "text/html");
        var addonsJs = doc.querySelector('#cart-addons');
        var itemsManagementJs = doc.querySelector('script[src*="'+sectionCart+'.js"]')

        $s.updateDynamicContent(document.getElementById(sectionCart=='side_cart' ? 'side-cart' : 'cart'), data[sectionCart], '.cart-items');

        await $s.globalEval(addonsJs.outerHTML);
        await $s.globalEval(itemsManagementJs);

      }});
      window.SideCart.updateSideCart(window.SideCart.isOpen());
    }

    async function updateQuantity() {
      $s.showLoadingOverlay();
      var data = {updates: {}};
      data.updates[(self.dataset.key || self.dataset.id)] = self.update.value;
      //await $s.cartUpdateDataFix(data);
      self.util.postUpdate(
         '/cart/update.js',
        data
      ).then(function(){
        updateUI();
      });
    }

    self.remove.addEventListener('click', function() {
      self.update.value = 0;
      updateQuantity();
    });
    self.update.addEventListener('change', function() {
      updateQuantity();
    });
    self.add.addEventListener('click', function() {
      var fd = new FormData();
      this.closest('.add-form').querySelectorAll('[name]:checked,[name]:not([type="checkbox"]):not([type="radio"])').forEach(x=>fd.append(x.name, x.value));
      fd.append('properties[_edit_options]', '{"r":true}');
      if(this.closest('.product-card').dataset.promo.includes("Gift")){
        fd.append('properties[_free_gift]', 'true');
      }else{
        fd.append('properties[_free_sample]', 'true');
      }
      fd.append('properties[_promo_hash]', self.settings.promo_hash);

      $s.showLoadingOverlay();
      self.util.postUpdate(
        '/cart/add.js',
        fd
      ).then(function() {
        updateUI();
      });

    });    
  }

}
customElements.define('free-sample-card', ComponentFreeSampleCard);


class ComponentFreeSampleCarousel extends HTMLElement {
  constructor() {
    super()
    this.slidesWrapper = this.querySelector('.keen-slider');
    this.slides = this.slidesWrapper.children;
    this.slidesPerViewDesktop = this.dataset.slidesPerViewDesktop;
    this.slidesPerViewTablet = this.dataset.slidesPerViewTablet;
    this.slidesPerViewMobile = this.dataset.slidesPerViewMobile;
    
    //carousel inits from initSections function
  }

  initCarousel() {
    if(this.slides.length > 0 && !this.initialized) {
      this.initialized = true;
      this.carousel = new KeenSlider(this.slidesWrapper, {
        mode: "free-snap",
        loop: false,
        navBar: this.querySelector('.keen-nav-bar'), 
        dots: this.querySelector('.keen-dots') ? this.querySelector('.keen-dots') : false, 
        rubberband: false,
        prevButton: this.querySelector('.keen-arrow.prev') || false,
        nextButton: this.querySelector('.keen-arrow.next') || false,
        customAnimation: this.effect=='fade' ? 'fade' : false,
        centered: false,
        autoplay: false,
        breakpoints: {
          '(min-width: 901px)': {
            spacing: 20,
            slidesPerView: this.slidesPerViewDesktop
          },
          '(min-width: 601px) and (max-width: 900px)': {
            spacing: 15,
            slidesPerView: this.slidesPerViewTablet
          },
          '(max-width: 600px)': {
            spacing: 10,
            slidesPerView: this.slidesPerViewMobile
          }
        }  
      });

      document.querySelectorAll('#side-cart .accordion .tab-btn').forEach((accordion)=>{
        accordion.addEventListener('click', e => {
          
            setTimeout(()=> {
              this.carousel.refresh();
              $s.matchHeight(this.querySelectorAll(".title"));
            }, 1000);
        });
        })
      
      window.addEventListener('resize', $s.throttle(()=>{
        setTimeout(()=> {
          this.carousel.refresh();
          $s.matchHeight(this.querySelectorAll(".title"));
        }, 1000);
      }, 200));
      $s.matchHeight(this.querySelectorAll(".title"));
    }    
  }

}
customElements.define('free-sample-carousel', ComponentFreeSampleCarousel);

class ComponentUpsellCarousel extends HTMLElement {
  constructor() {
    super();     
    this.sliderWrapper = this.querySelector('.keen-slider');
    this.sliderChildren = this.querySelectorAll('.keen-slider-slide');
    this.slidesPerViewDesktop = this.dataset.slidesPerViewDesktop;
    this.slidesPerViewTablet = this.dataset.slidesPerViewTablet;
    this.slidesPerViewMobile = this.dataset.slidesPerViewMobile;
    this.slider = null;
    this.useRecommendations = this.dataset.useRecommendations;
    if(this.useRecommendations){
      this.getProductRecommendations();
    } else {
      this.initCarousel();       
    }
}

async getProductRecommendations(){
  const productIds = this.dataset.productIds;

  const intent = this.dataset.intent;
  const limit = 6;
  const itemsContent = this.querySelector('.keen-slider');

  let queries = [];
  const ids = productIds && productIds.replaceAll(' ','').split(',') || [];
  for (let i = 0; i < ids.length; i++) {
    queries.splice(i, 0, {id: ids[i], intent: (intent=='related' ? 'related' : 'complementary')});
    if (i==0 && intent == 'mixed') {
      queries.push({id: ids[i], intent: 'related'});
    }
  }
  queries.forEach(x=>{x.url = `/recommendations/products?product_id=${x.id}&limit=${limit}&section_id=recommeded_cart_products&intent=${x.intent}` })
  var urls = queries.map(x=>{ return x.url});


  await $s.getDataFromUrls(urls).then((data)=>{


    var cardsHtml = [];
    var parser = new DOMParser();
    var productsLoaded = {};
    var shown = 0;

    queries.forEach(x=>{
      var url = x.url;
      var text = data[url];


      if(text) {

        var html = text;
        html = html.replaceAll('recommended_products_view', this.closest('.shopify-section').id);
        var doc = parser.parseFromString(html, 'text/html');
        doc.querySelectorAll('.item-upsell').forEach(card=>{


          if(shown < limit && !productsLoaded[card.dataset.productId]) {
            shown++;
            productsLoaded[card.dataset.productId] = 1;
            cardsHtml.push(card.parentNode.outerHTML);
          }
        });     
        
      }
    });

    itemsContent.innerHTML = cardsHtml.join('');
    this.sliderChildren = this.querySelectorAll('.keen-slider-slide');
    this.initCarousel();

  });

  



}

initCarousel() {  
  if (this.sliderChildren.length > 0) {

    this.slider = new KeenSlider(this.sliderWrapper, {
      mode: "snap",
      loop: false,
      dots: this.querySelector('.keen-dots') ? this.querySelector('.keen-dots') : false,
      navBar: this.querySelector('.keen-nav-bar') ? this.querySelector('.keen-nav-bar') : false,
      prevButton: this.querySelector('.keen-arrow.prev') ? this.querySelector('.keen-arrow.prev') : false,
      nextButton: this.querySelector('.keen-arrow.next') ? this.querySelector('.keen-arrow.next') : false,
      breakpoints: {
        '(min-width: 901px)': {
          spacing: 20,
          slidesPerView: this.slidesPerViewDesktop
        },
        '(min-width: 601px) and (max-width: 900px)': {
          spacing: 15,
          slidesPerView: this.slidesPerViewTablet
        },
        '(max-width: 600px)': {
          spacing: 10,
          slidesPerView: this.slidesPerViewMobile
        }
      } 
      });
      document.querySelectorAll('#side-cart .accordion .tab-btn').forEach((accordion)=>{
        accordion.addEventListener('click', e => {
          
            setTimeout(()=> {
              this.slider.refresh();
              $s.matchHeight(this.querySelectorAll(".title"));
            }, 1000);
        });
        })
    }

    this.sliderChildren.forEach((item) => {

      var itemKey = item.dataset.item;
      var button = item.querySelector('.btn.v1')
      var cartItem = { id: `${itemKey}`, quantity: 1};


      button.addEventListener('click', () => {
        if (window.SideCart) {
          window.SideCart.postAdd(cartItem);
        } else if (window.CartPage){
          window.CartPage.postAdd(cartItem);
        } 
      })
    })
  }   
}
customElements.define('upsell-carousel', ComponentUpsellCarousel);

class loginRewards extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (e) => {
      e.preventDefault();
      localStorage.setItem("fromRewardsPage", window.location.pathname);

      setTimeout(() => {
        window.location.href = '/account/login';
      }, 50);
    });
  }
}

if (!customElements.get('login-rewards')) {
  customElements.define('login-rewards', loginRewards);
}

document.querySelectorAll('[data-expand]').forEach((expandable) => {
  var trigger = expandable.querySelector('[data-expand-trigger]')
  var overlay = expandable.querySelector('.overlay')
  var content = expandable.querySelector('[data-expand-content]')
  trigger.addEventListener('click', (e)=>{
    e.preventDefault();
    collapse(expandable,content)
  })
  if(overlay){
    overlay.addEventListener('click', (e)=>{
      e.preventDefault();
      collapse(expandable,content)
    })
  }
})
var collapse = function(expandElement,content){
  expandElement.classList.toggle('active')
  $s.toggle([content]);
}